import { apiPost } from '../../api'

export const save_transaction = data => {
  return apiPost({
    endpoint: 'transactions/save_transaction',
    data: data
  })
}
